import { makeAutoObservable } from 'mobx';
import { MANAGER_UPGRADES, ManagerUpgradeType } from './data/managerData';
import { addMilliseconds, addSeconds } from 'date-fns';
import { DATA } from './data';
import { TripData } from './data.type';
import { LOUNGE_UPGRADES, LoungeUpgradeType } from './data/loungeData';
import { AirportSlug } from './data/airportData';

export class Lounge {
  public upgrades: { [k in LoungeUpgradeType]: number } = { chance: 0, ticket_price: 0 };

  constructor(
    public airportSlug: AirportSlug,
    public index: number,
  ) {
    makeAutoObservable(this);
  }

  getUpgradeValue(type: LoungeUpgradeType) {
    return LOUNGE_UPGRADES[type].valueFn(this.upgrades[type]);
  }

  getUpgradePrice(type: LoungeUpgradeType) {
    return Math.round(LOUNGE_UPGRADES[type].priceFn(this.upgrades[type], this.index));
  }

  increaseUpgradeLevel(type: LoungeUpgradeType) {
    this.upgrades[type]++;
    this.upgrades[type] = Math.min(this.upgrades[type], LOUNGE_UPGRADES[type].maxValue);
  }
}
